/** The signed-in session for the user menu (ADR 0012); kept apart from the gate to avoid an import cycle. */

import { createContext, useContext } from 'react';
import type { AuthSession } from '../api/auth.js';

export interface AuthInfo {
  session: AuthSession;
  /** Ends the session (POST /auth/logout) and returns to the login screen. */
  logout(): Promise<void>;
}

export const AuthContext = createContext<AuthInfo | null>(null);

/** The signed-in session, or null outside the gate (tests that render App alone). */
export function useAuth(): AuthInfo | null {
  return useContext(AuthContext);
}
